module.exports = __webpack_public_path__ + "static/yonhap-5399145e5f706a2c2b1d22f31f67bb07.png";